
<!-- <ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
      <a [routerLink]="['/']">Home</a>
  </li>
  <li>
      <a [routerLink]="['/meeting']">Meeting</a>
  </li>
  <li *ngIf="!restrictTabFlag">Schedule Meeting</li>
  <li *ngIf="restrictTabFlag">Edit Scheduled Meeting</li>
</ul> -->
<section class="card">
    <div class="card-header">
        <span class="cat__core__title">
            <strong>{{titleOnAddUpdate}}</strong>
        </span>
        <span style="float: right">
            <button *ngIf="isBoardMeetingSelected()" (click)="refresh()" class="btn btn-sm btn-default pull-right btn-refresh" type="button">
                <i class="fa fa-refresh"></i>&nbsp;
                Refresh
            </button>
            <a (click) = "back()">
                <button class="btn btn-sm btn-default pull-right btn-back" type="button">
                    <i class=" fa fa-chevron-circle-left"></i>
                    Back
                </button>
            </a>
        </span>
    </div>
    <div class="row">
        <div class="col-lg-12" id="meetingTabContainer">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" href="javascript: void(0);" data-toggle="tab" data-target="#MeetingDetails" aria-selected="IsMeetingDetailsActive"
                        role="tab">Meeting Details
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane active" id="MeetingDetails" role="tabcard">
                    <form [formGroup]="addDefaultMeetingForm" class="well" NoValidate>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-lg-2">
                                    <label class="form-control-label">Meeting Type</label>
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <select class="form-control" [formControl]="addDefaultMeetingForm.controls['MeetingType']"
                                            style="padding:6px;" required="required" *ngIf="!restrictTabFlag">
                                            <option value='' [selected]="true">Select</option>
                                            <option *ngFor="let meetingTypeList of meetingTypes" id="meetingTypeName" [value]="meetingTypeList._id">
                                                {{meetingTypeList.MeetingType}}
                                            </option>
                                        </select>
                                        <select class="form-control" [formControl]="addDefaultMeetingForm.controls['MeetingType']"
                                            style="padding:6px;" required="required" *ngIf="restrictTabFlag">
                                            <option [value]="MeetingTypeIDForEdit" [selected]="true">{{MeetingTypeNameForEdit}}</option>
                                        </select>
                                        <div *ngIf="addDefaultMeetingForm.controls['MeetingType'].hasError('required') && addDefaultMeetingForm.controls['MeetingType'].touched"
                                            class="form-control-error-custom">
                                            Meeting type is required.
                                        </div>
                                    </div>
                                </div>
  
                                <div class="col-lg-2">
                                    <label class="form-control-label">Venue</label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <textarea [formControl]="addDefaultMeetingForm.controls['MeetingPlace']" class="form-control" rows="3" style="padding:6px;"></textarea>
                                    </div>
                                </div>
  
                                <div class="col-lg-2">
                                    <label class="form-control-label">Name of person signing Notice</label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <input type="text" [formControl]="addDefaultMeetingForm.controls['NoticeSignatoryName']" class="form-control" style="padding:6px;">
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label class="form-control-label">Mobile Number</label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <input [formControl]="addDefaultMeetingForm.controls['ContactNumber']" class="form-control" pattern="^\d{10}$" (keydown)="onlyNumber($event)">
                                        <div *ngIf="addDefaultMeetingForm.controls['ContactNumber'].hasError('pattern') && addDefaultMeetingForm.controls['ContactNumber'].touched"
                                            class="form-control-error-custom">
                                            Mobile Number is not valid.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label class="form-control-label">Email address</label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <input type="text" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" [formControl]="addDefaultMeetingForm.controls['EmailID']"
                                            class="form-control" style="padding:6px;">
                                        <div *ngIf="addDefaultMeetingForm.controls['EmailID'].hasError('pattern')" class="form-control-error-custom">
                                            Mail id not valid.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label class="form-control-label">Designation of person signing Notice</label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <input type="text" [formControl]="addDefaultMeetingForm.controls['NoticeSignatoryDesignation']" class="form-control" style="padding:6px;">
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label class="form-control-label">DIN / ACS no.</label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <input type="text" [formControl]="addDefaultMeetingForm.controls['DinNumber']" class="form-control" style="padding:6px;" (keydown)="DinNumber($event)">
                                    </div>
                                </div>
                                <!-- <div class="col-lg-2">
                                    <label class="form-control-label" for="l0">Date of signing Notice</label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <div class="input-group" (click)="$event.stopPropagation()">
                                            <input class="form-control" [formControl]="addDefaultMeetingForm.controls['SigningNoticeDate']" [(ngModel)]="SigningNoticeDateModel"
                                                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="SigningNoticeDate"
                                                [maxDate]="MeetingDateModel" ngbDatepicker #b="ngbDatepicker" (click)="b.toggle();">
                                            <button class="input-group-addon" (click)="b.toggle();" type="button">
                                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="col-lg-2">
                                    <label class="form-control-label">Place of signing Notice</label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <input type="text" [formControl]="addDefaultMeetingForm.controls['SigningNoticePlace']" class="form-control" style="padding:6px;">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-sm btn-primary" *ngIf="!restrictTabFlag" [disabled]="!addDefaultMeetingForm.valid || disabledOnclick"
                                (click)="addAndUpdateDefaultMeeting()">
                                <i class="fa fa-save"></i>&nbsp;Save</button>
                            <button type="button" class="btn btn-sm btn-primary" *ngIf="restrictTabFlag" [disabled]="!addDefaultMeetingForm.valid || disabledOnclick"
                                (click)="addAndUpdateDefaultMeeting()">
                                <i class="fa fa-save"></i>&nbsp;Update</button>
                            <button type="button" class="btn-sm btn btn-default" data-toggle="modal" data-target="#clearDefaultMeetingDataModal">
                                <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                        </div>
  
                        <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby=""
                            aria-hidden="true" style="top: 50px;">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div id="alertTitle" class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                                        Title!
                                    </div>
                                    <div class="modal-body">
                                        <div id="alertMessage">
                                            Message..
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
  
                        <div class="modal fade" id="clearDefaultMeetingDataModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
                            aria-labelledby="" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="myModalLabelForDelete">
                                            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                            <i class="fa fa-times"></i>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                Are you sure you want to clear Meeting details?
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-sm btn-danger" (click)="back()" data-dismiss="modal">
                                            <i class="fa fa-check"></i>&nbsp;Yes</button>
                                        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                                            <i class="fa fa-times"></i>&nbsp;No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  </section>
  <app-alert></app-alert>